import React, { useEffect, useState } from "react";
import { Link, redirect, useNavigate } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import SimpleBar from "simplebar-react";
import socketIO from "socket.io-client";
import { useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { formatDistanceToNow } from "date-fns";

import { addMissingAppRequest } from "../../../store/iOS/iOSmissingApp/missingAppAction";
import SDK from "../../../config";

const NotificationDropdown = ({ t }) => {
    const [menu, setMenu] = useState(false);
    const socket = socketIO(SDK.SOCKET_URL);
    const dispatch = useDispatch();
    const [appData, setAppData] = useState([]);
    const navigate = useNavigate()

    const toggle = () => {
        setMenu((prevMenu) => !prevMenu);
    };

    useEffect(() => {
        socket.emit("ios-all-missing-apps", { offset: 0, limit: 5 });
        socket.on("ios-all-missing-apps-response", (data) => {
            if (data.length > 0) {
                const updatedData = data.map((app) => ({
                    ...app,
                    adjustedTimestamp: new Date(app.createdAt),
                }));
                setAppData(updatedData);
            }
        });

        return () => {
            socket.off("ios-all-missing-apps-response");
        };
    }, []);


    const handleClick = (appId) => {

        socket.emit("update-missing-app-AdminRead", appId);
        setAppData((prevData) =>
            prevData.map((app) =>
                app.appId === appId ? { ...app, isAdminRead: true } : app
            )
        );
        navigate("/iOS-missing-app", { state: { appId } });
    };

    useEffect(() => {
        socket.on("newMissingApp", (data) => {
            const adjustedTimestamp = new Date(data.createdAt);

            setAppData((prevData) => {
                if (!prevData) {
                    return [{
                        ...data,
                        adjustedTimestamp: adjustedTimestamp,
                    }];
                }

                const exists = prevData.some((app) => app.appId === data.appId);
                if (exists) {
                    return prevData;
                }

                return [{
                    ...data,
                    adjustedTimestamp: adjustedTimestamp,
                }, ...prevData];
            });

            dispatch(addMissingAppRequest(data));
        });

        return () => {
            socket.off("newMissingApp");
        };
    }, [dispatch]);

    // Handle "Mark All Read"
    const markAllRead = () => {
        const unreadAppIds = appData.filter((app) => !app.isAdminRead).map((app) => app.appId);
        if (unreadAppIds.length > 0) {
            socket.emit("update-missing-app-AdminRead", unreadAppIds);

            setAppData((prevData) =>
                prevData.map((app) => ({ ...app, isAdminRead: true }))
            );
        }
    };


    return (
        <React.Fragment>
            <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block">
                <DropdownToggle
                    tag="button"
                    className="btn header-item noti-icon waves-effect"
                    id="page-header-notifications-dropdown"
                >
                    <i className="ri-notification-3-line"></i>
                    {appData?.filter(app => app.isAdminRead === false).length > 0 && (
                        <span className="noti-dot"></span>
                    )}
                </DropdownToggle>
                <DropdownMenu
                    className="dropdown-menu-end dropdown-menu-lg p-0"
                    aria-labelledby="page-header-notifications-dropdown"
                >
                    <div className="p-3" style={{ borderBottom: '1px solid #ddd' }}>
                        <Row className="align-items-center">
                            <Col>
                                <h6 className="m-0">{t("Notifications")}</h6>
                            </Col>
                        </Row>
                    </div>
                    <SimpleBar style={{ maxHeight: "230px" }}>
                        {appData && appData.length > 0 ? (
                            appData.map((app, index) => (
                                <div
                                    onClick={() => handleClick(app.appId)}
                                    className="text-reset notification-item"
                                    key={index}
                                    style={{
                                        cursor: 'pointer',
                                        transition: 'background-color 0.3s',
                                    }}
                                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f8f9fa')} // Light grey
                                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                                >
                                    <div
                                        className="d-flex"
                                        style={{
                                            backgroundColor: app.isAdminRead === false ? '#f0f8ff' : 'transparent',
                                            borderLeft: app.isAdminRead === false ? '5px solid #00bcd4' : 'none',
                                            paddingBottom: '5px',
                                        }}
                                    >
                                        <div className="avatar-xs me-3 mt-2">
                                            <div className="avatar-title rounded-circle">
                                                <img
                                                    src={app.iconUrl}
                                                    alt={app.appName}
                                                    style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
                                                />
                                            </div>
                                        </div>
                                        <div className="flex-1">
                                            <h6 className="mt-0 mb-1">{app.appName}</h6>
                                            <div className="font-size-12 text-muted">
                                                <p className="mb-1">{t("New Missing App Received")}</p>
                                                <p className="mb-0">
                                                    <i className="mdi mdi-clock-outline me-1"></i>
                                                    {formatDistanceToNow(new Date(app.adjustedTimestamp), { addSuffix: true })}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <hr style={{
                                        margin: '0px 0',
                                        borderTop: '1px solid #ddd',
                                        borderColor: '#ddd',
                                        marginBottom: '0',
                                    }} />
                                </div>
                            ))
                        ) : (
                            <div className="text-center p-3">
                                <p className="mb-0 font-size-14 text-muted">{t("No notifications found")}</p>
                            </div>
                        )}

                    </SimpleBar>

                    <div className="p-2 border-top">
                        <Link
                            onClick={markAllRead}
                            className="btn btn-sm btn-link font-size-14 btn-block text-center"
                        >
                            {t("Mark All Read")}
                        </Link>
                    </div>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default withTranslation()(NotificationDropdown);
